/**
 * 对外地址的唯一来源。
 *
 * 页面里不要写死 GitHub / 站点 URL：换账号或换域名时只改这里。
 */

// 项目仓库
export const PROJECT_REPO_URL = 'https://github.com/webmonitor/WebMonitor';

// 维护者 / 用户主页
export const PROJECT_AUTHOR_URL = 'https://github.com/ox0pine';
